/**
 * Translations Context for Internationalization
 * 
 * This module provides React Context for managing translations
 * and language switching functionality.
 */

import React, { createContext, useContext } from 'react';

const translations = {
  ar: {
    title: "خزنلي - نظام إدارة التخزين للأدمن",
    login: "تسجيل الدخول",
    username: "اسم المستخدم",
    password: "كلمة المرور",
    dashboard: "لوحة التحكم",
    orders: "إدارة الطلبات",
    retrieval: "طلبات الاسترجاع",
    customers: "إدارة العملاء",
    whatsapp: "إدارة الواتساب",
    calculator: "حاسبة الأسعار",
    services: "إدارة الخدمات",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    totalOrders: "إجمالي الطلبات",
    totalCustomers: "إجمالي العملاء",
    pendingOrders: "طلبات في الانتظار",
    activeOrders: "طلبات نشطة",
    totalRevenue: "إجمالي الإيرادات",
    monthlyOrders: "طلبات الشهر",
    orderNumber: "رقم الطلب",
    customerName: "اسم العميل",
    phone: "الهاتف",
    space: "المساحة",
    duration: "المدة",
    price: "السعر",
    status: "الحالة",
    actions: "الإجراءات",
    pending: "في الانتظار",
    approved: "مقبول",
    rejected: "مرفوض",
    active: "طلبات نشطة حاليا",
    in_warehouse: "في المستودع",
    delivering_to_customer: "في حالة توصيل من المستودع الى العميل",
    delivering_to_warehouse: "في حالة توصيل من العميل المستودع",
    completed: "طلبات مكتملة تم توصيلها للعميل",
    needs_attention: "طلبات عليها ملاحظات",
    retrieval_requested: "طلب استرجاع مطلوب",
    retrieval_approved: "طلب استرجاع معتمد",
    retrieval_delivering: "في حالة توصيل للاسترجاع",
    retrieval_completed: "طلب استرجاع مكتمل",
    updateStatus: "تحديث الحالة",
    orderDetails: "تفاصيل الطلب",
    adminNotes: "ملاحظات الإدارة",
    approve: "قبول",
    reject: "رفض",
    viewDetails: "عرض التفاصيل",
    address: "العنوان",
    createdAt: "تاريخ الإنشاء",
    sessionId: "معرف الجلسة",
    step: "الخطوة",
    lastUpdated: "آخر تحديث",
    calculate: "احسب",
    sqm: "متر مربع",
    months: "شهور",
    packaging: "التغليف",
    pickup: "الاستلام",
    delivery: "التوصيل",
    assembly: "التركيب",
    insurance: "التأمين",
    basePrice: "السعر الأساسي",
    servicesPrice: "سعر الخدمات",
    totalPrice: "السعر الإجمالي",
    sar: "ريال سعودي",
    whatsappBot: "بوت الواتساب",
    connected: "متصل",
    disconnected: "غير متصل",
    connectWhatsapp: "ربط الواتساب",
    addFeature: "إضافة ميزة",
    editFeature: "تعديل ميزة",
    deleteFeature: "حذف ميزة",
    featureName: "اسم الميزة",
    featureNameAr: "اسم الميزة بالعربية",
    featureDescription: "وصف الميزة",
    featureDescriptionAr: "وصف الميزة بالعربية",
    featurePrice: "سعر الميزة",
    active: "نشط",
    inactive: "غير نشط",
    save: "حفظ",
    cancel: "إلغاء",
    orderDetails: "تفاصيل الطلب",
    customerDetails: "تفاصيل العميل",
    items: "المحتويات",
    additionalServices: "الخدمات الإضافية",
    images: "الصور",
    adminNotes: "ملاحظات الإدارة",
    totalOrders: "إجمالي الطلبات",
    totalSpent: "إجمالي المبالغ المدفوعة",
    customerOrders: "طلبات العميل",
    orderHistory: "تاريخ الطلبات",
    close: "إغلاق",
    sendMessage: "إرسال رسالة",
    whatsappSessions: "جلسات الواتساب",
    messageContent: "محتوى الرسالة",
    send: "إرسال",
    updateStatus: "تحديث الحالة",
    changeStatus: "تغيير الحالة",
    selectStatus: "اختر الحالة",
    autoTransition: "انتقال تلقائي",
    validTransitions: "الانتقالات المتاحة",
    statusUpdated: "تم تحديث الحالة بنجاح",
    statusUpdateFailed: "فشل في تحديث الحالة",
    notes: "ملاحظات",
    totalOrders: "إجمالي الطلبات",
    totalAmounts: "إجمالي المبالغ",
    notSpecified: "غير محدد",
    deliveryAddress: "عنوان التوصيل",
    approve: "اعتماد",
    startDelivery: "بدء التوصيل",
    complete: "إكمال",
    adminNotesOptional: "ملاحظات الإدارة (اختياري)",
    phoneNumber: "رقم الهاتف",
    currentStep: "الخطوة الحالية",
    lastUpdate: "آخر تحديث",
    creationDate: "تاريخ الإنشاء",
    viewConversation: "عرض المحادثة",
    recentOrders: "أحدث الطلبات",
    settings: "الإعدادات",
    manageAppSettings: "إدارة إعدادات التطبيق والأسعار",
    whatsappSettings: "إعدادات الواتساب",
    priceSettings: "إعدادات الأسعار",
    generalSettings: "الإعدادات العامة",
    connectWhatsapp: "ربط الواتساب بالخدمة",
    whatsappQRCode: "رمز QR للواتساب",
    scanQRCode: "امسح الرمز لربط الواتساب بالخدمة",
    update: "تحديث",
    noCodeAvailable: "لا يوجد رمز متاح حالياً - اضغط على \"تحديث\" للحصول على رمز جديد QR",
    tryAgain: "المحاولة مرة أخرى",
    howToConnect: "كيفية الربط",
    openWhatsapp: "افتح الواتساب على هاتفك",
    clickThreeDots: "اضغط على النقاط الثلاث (3) أو الإعدادات",
    pricePerSqm: "سعر المتر المربع في اليوم (ريال)",
    pricePerKg: "سعر الكيلوغرام في اليوم (ريال)",
    currency: "العملة",
    saveSettings: "حفظ الإعدادات",
    saving: "جاري الحفظ...",
    appNameEnglish: "اسم التطبيق (إنجليزي)",
    appNameArabic: "اسم التطبيق (عربي)",
    companyNameEnglish: "اسم الشركة (إنجليزي)",
    companyNameArabic: "اسم الشركة (عربي)",
    contactPhone: "رقم الهاتف",
    contactEmail: "البريد الإلكتروني",
    addressEnglish: "العنوان (إنجليزي)",
    addressArabic: "العنوان (عربي)",
    companyAppInfo: "معلومات الشركة والتطبيق",
    loadingSettings: "جاري تحميل الإعدادات...",
    servicesManagement: "إدارة الخدمات",
    manageStorageServices: "إدارة خدمات التخزين والخدمات الإضافية",
    addService: "إضافة خدمة",
    name: "الاسم",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    edit: "تعديل",
    delete: "حذف",
    addServiceModal: "إضافة خدمة",
    editServiceModal: "تعديل خدمة",
    nameEnglish: "الاسم (إنجليزي)",
    nameArabic: "الاسم (عربي)",
    descriptionEnglish: "الوصف (إنجليزي)",
    descriptionArabic: "الوصف (عربي)",
    cancel: "إلغاء",
    add: "إضافة",
    save: "حفظ",
    loadingData: "جاري تحميل البيانات...",
    noServices: "لا توجد خدمات",
    startAddingServices: "ابدأ بإضافة خدمات جديدة",
    addFirstService: "إضافة أول خدمة",
    confirmDelete: "هل أنت متأكد من حذف هذه الخدمة؟",
    pricingManagement: "إدارة الأسعار",
    manageStoragePricing: "إدارة أسعار التخزين والخدمات",
    addNew: "إضافة جديد",
    basePrice: "السعر الأساسي",
    space: "المساحة",
    duration: "المدة",
    pricePerSqmMonth: "لكل م²/شهر",
    squareMeters: "م²",
    months: "شهر",
    addPricingModal: "إضافة سعر تخزين",
    editPricingModal: "تعديل سعر تخزين",
    baseRatePerSqmMonth: "السعر الأساسي (ريال/م²/شهر)",
    minSpace: "أقل مساحة (م²)",
    maxSpace: "أكبر مساحة (م²)",
    minDuration: "أقل مدة (شهر)",
    maxDuration: "أكبر مدة (شهر)",
    monthlyDiscount: "خصم شهري (%)",
    bulkDiscount: "خصم الكمية (%)",
    priority: "الأولوية",
    noData: "لا توجد بيانات",
    startAddingPricing: "ابدأ بإضافة أسعار التخزين",
    addFirstItem: "إضافة أول عنصر",
    confirmDeleteItem: "هل أنت متأكد من حذف هذا العنصر؟",
    whatsappManagement: "إدارة الواتساب",
    searchWhatsappSessions: "البحث في جلسات الواتساب...",
    activeSessions: "الجلسات النشطة",
    conversationLog: "سجل المحادثات",
    whatsappConversations: "محادثات الواتساب",
    whatsappBot: "بوت الواتساب",
    status: "الحالة",
    connected: "متصل",
    disconnected: "غير متصل",
    user: "المستخدم",
    serviceStatus: "حالة الخدمة",
    lastUpdate: "آخر تحديث",
    error: "خطأ",
    checkingWhatsappStatus: "جاري فحص حالة الواتساب...",
    priceCalculator: "حاسبة الأسعار",
    calculateStoragePrice: "احسب سعر التخزين بسهولة وسرعة",
    spaceAndDuration: "المساحة والمدة",
    dataEntry: "إدخال البيانات",
    requiredSpace: "المساحة المطلوبة (م²)",
    enterRequiredSpace: "أدخل المساحة المطلوبة",
    durationMonths: "المدة (شهر)",
    enterDurationMonths: "أدخل المدة بالأشهر",
    calculatePrice: "احسب السعر",
    calculating: "جاري الحساب...",
    calculationResults: "نتائج الحساب",
    noResults: "لا توجد نتائج",
    enterDataAndCalculate: "أدخل البيانات المطلوبة واضغط على \"احسب السعر\" لعرض النتائج التفصيلية",
    loadingPricingData: "جاري تحميل بيانات الأسعار...",
    orderInfo: "معلومات الطلب",
    customerInfo: "معلومات العميل",
    storageDetails: "تفاصيل التخزين",
    adminNotes: "ملاحظات الإدارة",
    noNotes: "لا توجد ملاحظات",
    approvalActions: "إجراءات الموافقة",
    editPrice: "تعديل السعر",
    setPrice: "تحديد السعر",
    priceSAR: "السعر (ريال سعودي)",
    enterPrice: "أدخل السعر",
    savePrice: "حفظ السعر",
    orderDetails: "تفاصيل الطلب",
    orderSummary: "تفاصيل الطلب",
    space: "المساحة",
    duration: "المدة",
    currency: "العملة",
    saudiRiyal: "ريال سعودي",
    pricePerSquareMeter: "سعر المتر المربع",
    priceDetails: "تفاصيل السعر",
    spacePrice: "سعر المساحة",
    additionalServices: "الخدمات الإضافية",
    totalAmount: "المجموع الإجمالي",
    includingFeesTaxes: "شامل جميع الرسوم والضرائب",
    calculationDetails: "تفاصيل الحساب",
    spacePriceCalculation: "حساب سعر المساحة",
    totalAmountFinal: "المجموع الإجمالي",
    confirmData: "تأكيد البيانات",
    pleaseReviewData: "يرجى مراجعة البيانات",
    confirmDataBeforeProceeding: "تأكد من صحة البيانات المدخلة قبل المتابعة",
    space: "المساحة",
    duration: "المدة",
    spacePrice: "سعر المساحة",
    total: "المجموع",
    confirm: "تأكيد",
    areaAndDurationMustBeGreaterThanZero: "المساحة والمدة يجب أن تكون أكبر من 0",
    failedToLoadPricingData: "فشل في تحميل بيانات الأسعار",
    errorLoadingPricingData: "خطأ في تحميل بيانات الأسعار",
    noPricingSettingsAvailable: "لا توجد إعدادات أسعار متاحة",
    errorCalculatingPrice: "خطأ في حساب السعر",
    currentPricing: "التسعير الحالي",
    pendingRetrievalRequests: "طلبات الاسترجاع المعلقة",
    completedRetrievalRequests: "طلبات الاسترجاع المكتملة",
    checkingIdentity: "جاري التحقق من الهوية...",
    loadingData: "جاري تحميل البيانات...",
    customerDetails: "تفاصيل العميل",
    idNumber: "رقم الهوية",
    notSpecified: "غير محدد",
    customerStatistics: "إحصائيات العميل",
    totalOrders: "إجمالي الطلبات",
    totalAmounts: "إجمالي المبالغ",
    customerOrders: "طلبات العميل",
    conversationLog: "سجل المحادثات",
    messageType: "نوع الرسالة",
    all: "الكل",
    user: "المستخدم",
    bot: "البوت",
    searchInConversations: "البحث في المحادثات...",
    noConversationsAvailable: "لا توجد محادثات متاحة",
    message: "رسالة",
    theUser: "المستخدم",
    theBot: "البوت",
    attachment: "مرفق",
    whatsappQRCode: "رمز QR للواتساب",
    scanCodeToConnect: "امسح الرمز لربط الواتساب بالخدمة",
    updating: "جاري التحديث...",
    update: "تحديث",
    loadingQRCode: "جاري تحميل رمز QR...",
    noQRCodeAvailable: "لا يوجد رمز QR متاح حالياً",
    tryAgain: "المحاولة مرة أخرى",
    scanThisCodeWithWhatsapp: "امسح هذا الرمز باستخدام الواتساب لربط الحساب",
    ifPhoneCannotReadCode: "إذا لم يتمكن الهاتف من قراءة الرمز، اضغط على \"تحديث\" للحصول على رمز جديد",
    lastUpdate: "آخر تحديث",
    howToConnect: "كيفية الربط",
    openWhatsappOnPhone: "افتح الواتساب على هاتفك",
    clickThreeDotsOrSettings: "اضغط على النقاط الثلاث (⋮) أو الإعدادات",
    chooseLinkedDevices: "اختر \"الأجهزة المرتبطة\" أو \"Linked Devices\"",
    clickLinkDevice: "اضغط على \"ربط جهاز\" أو \"Link a Device\"",
    scanQRCodeAbove: "امسح رمز QR أعلاه",
    failedToLoadQRCode: "فشل في تحميل رمز QR",
    failedToUpdateQRCode: "فشل في تحديث رمز QR",
    failedToDisplayQRCode: "فشل في عرض رمز QR",
    noQRCodeAvailableAfterRefresh: "لا يوجد رمز QR متاح حالياً - قد تحتاج إلى إعادة تشغيل خدمة الواتساب",
    noQRCodeAvailableClickUpdate: "لا يوجد رمز QR متاح حالياً - اضغط على \"تحديث\" للحصول على رمز جديد",
    whatsappDeviceConnected: "الجهاز متصل بنجاح",
    whatsappConnectedMessage: "حساب الواتساب مرتبط ويعمل حالياً",
    connectedDevice: "الجهاز المرتبط",
    disconnectWhatsApp: "قطع الاتصال",
    disconnecting: "جاري قطع الاتصال...",
    disconnectFailed: "فشل في قطع الاتصال",
    disconnectToScanNewQR: "بعد قطع الاتصال، سيظهر رمز QR جديد لربط جهاز آخر",
    phoneNumber: "رقم الهاتف",
    retrievalDetails: "تفاصيل الاسترجاع",
    deliveryAddress: "عنوان التوصيل",
    requestedDeliveryDate: "تاريخ التوصيل المطلوب",
    retrievalRequestDate: "تاريخ طلب الاسترجاع",
    close: "إغلاق"
  },
  en: {
    title: "Khazenly - Admin Storage Management System",
    login: "Login",
    username: "Username",
    password: "Password",
    dashboard: "Dashboard",
    orders: "Orders Management",
    retrieval: "Retrieval Requests",
    customers: "Customers Management",
    whatsapp: "WhatsApp Management",
    calculator: "Price Calculator",
    services: "Service Management",
    settings: "Settings",
    logout: "Logout",
    totalOrders: "Total Orders",
    totalCustomers: "Total Customers",
    pendingOrders: "Pending Orders",
    activeOrders: "Active Orders",
    totalRevenue: "Total Revenue",
    monthlyOrders: "Monthly Orders",
    orderNumber: "Order Number",
    customerName: "Customer Name",
    phone: "Phone",
    space: "Space",
    duration: "Duration",
    price: "Price",
    status: "Status",
    actions: "Actions",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    active: "Active",
    in_warehouse: "In Warehouse",
    delivering_to_customer: "Delivering to Customer",
    delivering_to_warehouse: "Delivering to Warehouse",
    completed: "Completed",
    needs_attention: "Needs Attention",
    retrieval_requested: "Retrieval Requested",
    retrieval_approved: "Retrieval Approved",
    retrieval_delivering: "Retrieval Delivering",
    retrieval_completed: "Retrieval Completed",
    updateStatus: "Update Status",
    orderDetails: "Order Details",
    adminNotes: "Admin Notes",
    approve: "Approve",
    reject: "Reject",
    viewDetails: "View Details",
    address: "Address",
    createdAt: "Created At",
    sessionId: "Session ID",
    step: "Step",
    lastUpdated: "Last Updated",
    calculate: "Calculate",
    sqm: "sqm",
    months: "months",
    packaging: "Packaging",
    pickup: "Pickup",
    delivery: "Delivery",
    assembly: "Assembly",
    insurance: "Insurance",
    basePrice: "Base Price",
    servicesPrice: "Services Price",
    totalPrice: "Total Price",
    sar: "SAR",
    whatsappBot: "WhatsApp Bot",
    connected: "Connected",
    disconnected: "Disconnected",
    connectWhatsapp: "Connect WhatsApp",
    addFeature: "Add Feature",
    editFeature: "Edit Feature",
    deleteFeature: "Delete Feature",
    featureName: "Feature Name",
    featureNameAr: "Feature Name (Arabic)",
    featureDescription: "Feature Description",
    featureDescriptionAr: "Feature Description (Arabic)",
    featurePrice: "Feature Price",
    active: "Active",
    inactive: "Inactive",
    save: "Save",
    cancel: "Cancel",
    orderDetails: "Order Details",
    customerDetails: "Customer Details",
    items: "Items",
    additionalServices: "Additional Services",
    images: "Images",
    adminNotes: "Admin Notes",
    totalOrders: "Total Orders",
    totalSpent: "Total Spent",
    customerOrders: "Customer Orders",
    orderHistory: "Order History",
    close: "Close",
    sendMessage: "Send Message",
    whatsappSessions: "WhatsApp Sessions",
    messageContent: "Message Content",
    send: "Send",
    updateStatus: "Update Status",
    changeStatus: "Change Status",
    selectStatus: "Select Status",
    autoTransition: "Auto Transition",
    validTransitions: "Valid Transitions",
    statusUpdated: "Status updated successfully",
    statusUpdateFailed: "Failed to update status",
    notes: "Notes",
    totalOrders: "Total Orders",
    totalAmounts: "Total Amounts",
    notSpecified: "Not Specified",
    deliveryAddress: "Delivery Address",
    approve: "Approve",
    startDelivery: "Start Delivery",
    complete: "Complete",
    adminNotesOptional: "Admin Notes (Optional)",
    phoneNumber: "Phone Number",
    currentStep: "Current Step",
    lastUpdate: "Last Update",
    creationDate: "Creation Date",
    viewConversation: "View Conversation",
    recentOrders: "Recent Orders",
    settings: "Settings",
    manageAppSettings: "Manage application and price settings",
    whatsappSettings: "WhatsApp Settings",
    priceSettings: "Price Settings",
    generalSettings: "General Settings",
    connectWhatsapp: "Connect WhatsApp to the service",
    whatsappQRCode: "WhatsApp QR Code",
    scanQRCode: "Scan the code to connect WhatsApp to the service",
    update: "Update",
    noCodeAvailable: "No QR code available currently - click \"Update\" to get a new QR code",
    tryAgain: "Try Again",
    howToConnect: "How to connect",
    openWhatsapp: "Open WhatsApp on your phone",
    clickThreeDots: "Click on the three dots (3) or Settings",
    pricePerSqm: "Price per square meter per day (SAR)",
    pricePerKg: "Price per kilogram per day (SAR)",
    currency: "Currency",
    saveSettings: "Save Settings",
    saving: "Saving...",
    appNameEnglish: "Application Name (English)",
    appNameArabic: "Application Name (Arabic)",
    companyNameEnglish: "Company Name (English)",
    companyNameArabic: "Company Name (Arabic)",
    contactPhone: "Phone Number",
    contactEmail: "Email",
    addressEnglish: "Address (English)",
    addressArabic: "Address (Arabic)",
    companyAppInfo: "Company and Application Information",
    loadingSettings: "Loading settings...",
    servicesManagement: "Services Management",
    manageStorageServices: "Management of Storage Services and Additional Services",
    addService: "Add Service",
    name: "Name",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    edit: "Edit",
    delete: "Delete",
    addServiceModal: "Add Service",
    editServiceModal: "Edit Service",
    nameEnglish: "Name (English)",
    nameArabic: "Name (Arabic)",
    descriptionEnglish: "Description (English)",
    descriptionArabic: "Description (Arabic)",
    cancel: "Cancel",
    add: "Add",
    save: "Save",
    loadingData: "Loading data...",
    noServices: "No Services",
    startAddingServices: "Start adding new services",
    addFirstService: "Add First Service",
    confirmDelete: "Are you sure you want to delete this service?",
    pricingManagement: "Pricing Management",
    manageStoragePricing: "Manage storage and service pricing",
    addNew: "Add New",
    basePrice: "Base Price",
    space: "Space",
    duration: "Duration",
    pricePerSqmMonth: "per m²/month",
    squareMeters: "m²",
    months: "month",
    addPricingModal: "Add Storage Price",
    editPricingModal: "Edit Storage Price",
    baseRatePerSqmMonth: "Base Rate (SAR/m²/month)",
    minSpace: "Minimum Space (m²)",
    maxSpace: "Maximum Space (m²)",
    minDuration: "Minimum Duration (month)",
    maxDuration: "Maximum Duration (month)",
    monthlyDiscount: "Monthly Discount (%)",
    bulkDiscount: "Bulk Discount (%)",
    priority: "Priority",
    noData: "No Data",
    startAddingPricing: "Start adding storage pricing",
    addFirstItem: "Add First Item",
    confirmDeleteItem: "Are you sure you want to delete this item?",
    whatsappManagement: "WhatsApp Management",
    searchWhatsappSessions: "Search in WhatsApp sessions...",
    activeSessions: "Active Sessions",
    conversationLog: "Conversation Log",
    whatsappConversations: "WhatsApp Conversations",
    whatsappBot: "WhatsApp Bot",
    status: "Status",
    connected: "Connected",
    disconnected: "Disconnected",
    user: "User",
    serviceStatus: "Service Status",
    lastUpdate: "Last Update",
    error: "Error",
    checkingWhatsappStatus: "Checking WhatsApp status...",
    priceCalculator: "Price Calculator",
    calculateStoragePrice: "Calculate storage price easily and quickly",
    spaceAndDuration: "Space and Duration",
    dataEntry: "Data Entry",
    requiredSpace: "Required Space (m²)",
    enterRequiredSpace: "Enter required space",
    durationMonths: "Duration (month)",
    enterDurationMonths: "Enter duration in months",
    calculatePrice: "Calculate Price",
    calculating: "Calculating...",
    calculationResults: "Calculation Results",
    noResults: "No Results",
    enterDataAndCalculate: "Enter the required data and click \"Calculate Price\" to view detailed results",
    loadingPricingData: "Loading pricing data...",
    orderInfo: "Order Information",
    customerInfo: "Customer Information",
    storageDetails: "Storage Details",
    adminNotes: "Admin Notes",
    noNotes: "No Notes",
    approvalActions: "Approval Actions",
    editPrice: "Edit Price",
    setPrice: "Set Price",
    priceSAR: "Price (Saudi Riyal)",
    enterPrice: "Enter Price",
    savePrice: "Save Price",
    orderDetails: "Order Details",
    orderSummary: "Order Summary",
    space: "Space",
    duration: "Duration",
    currency: "Currency",
    saudiRiyal: "Saudi Riyal",
    pricePerSquareMeter: "Price per Square Meter",
    priceDetails: "Price Details",
    spacePrice: "Space Price",
    additionalServices: "Additional Services",
    totalAmount: "Total Amount",
    includingFeesTaxes: "Including all fees and taxes",
    calculationDetails: "Calculation Details",
    spacePriceCalculation: "Space Price Calculation",
    totalAmountFinal: "Total Amount",
    confirmData: "Confirm Data",
    pleaseReviewData: "Please review the data",
    confirmDataBeforeProceeding: "Make sure the entered data is correct before proceeding",
    space: "Space",
    duration: "Duration",
    spacePrice: "Space Price",
    total: "Total",
    confirm: "Confirm",
    areaAndDurationMustBeGreaterThanZero: "Area and duration must be greater than 0",
    failedToLoadPricingData: "Failed to load pricing data",
    errorLoadingPricingData: "Error loading pricing data",
    noPricingSettingsAvailable: "No pricing settings available",
    errorCalculatingPrice: "Error calculating price",
    currentPricing: "Current Pricing",
    pendingRetrievalRequests: "Pending Retrieval Requests",
    completedRetrievalRequests: "Completed Retrieval Requests",
    checkingIdentity: "Checking identity...",
    loadingData: "Loading data...",
    customerDetails: "Customer Details",
    idNumber: "ID Number",
    notSpecified: "Not Specified",
    customerStatistics: "Customer Statistics",
    totalOrders: "Total Orders",
    totalAmounts: "Total Amounts",
    customerOrders: "Customer Orders",
    conversationLog: "Conversation Log",
    messageType: "Message Type",
    all: "All",
    user: "User",
    bot: "Bot",
    searchInConversations: "Search in conversations...",
    noConversationsAvailable: "No conversations available",
    message: "Message",
    theUser: "User",
    theBot: "Bot",
    attachment: "Attachment",
    whatsappQRCode: "WhatsApp QR Code",
    scanCodeToConnect: "Scan the code to connect WhatsApp to the service",
    updating: "Updating...",
    update: "Update",
    loadingQRCode: "Loading QR code...",
    noQRCodeAvailable: "No QR code available currently",
    tryAgain: "Try Again",
    scanThisCodeWithWhatsapp: "Scan this code with WhatsApp to link the account",
    ifPhoneCannotReadCode: "If the phone cannot read the code, click \"Update\" to get a new code",
    lastUpdate: "Last Update",
    howToConnect: "How to connect",
    openWhatsappOnPhone: "Open WhatsApp on your phone",
    clickThreeDotsOrSettings: "Click on the three dots (⋮) or Settings",
    chooseLinkedDevices: "Choose \"Linked Devices\" or \"الأجهزة المرتبطة\"",
    clickLinkDevice: "Click on \"Link a Device\" or \"ربط جهاز\"",
    scanQRCodeAbove: "Scan the QR code above",
    failedToLoadQRCode: "Failed to load QR code",
    failedToUpdateQRCode: "Failed to update QR code",
    failedToDisplayQRCode: "Failed to display QR code",
    noQRCodeAvailableAfterRefresh: "No QR code available currently - you may need to restart the WhatsApp service",
    noQRCodeAvailableClickUpdate: "No QR code available currently - click \"Update\" to get a new QR code",
    whatsappDeviceConnected: "Device connected successfully",
    whatsappConnectedMessage: "WhatsApp account is linked and working",
    connectedDevice: "Linked device",
    disconnectWhatsApp: "Disconnect",
    disconnecting: "Disconnecting...",
    disconnectFailed: "Failed to disconnect",
    disconnectToScanNewQR: "After disconnecting, a new QR code will appear to link another device",
    phoneNumber: "Phone number",
    retrievalDetails: "Retrieval Details",
    deliveryAddress: "Delivery Address",
    requestedDeliveryDate: "Requested Delivery Date",
    retrievalRequestDate: "Retrieval Request Date",
    close: "Close"
  }
};

const TranslationsContext = createContext();

export const TranslationsProvider = ({ children }) => {
  const value = {
    translations
  };

  return (
    <TranslationsContext.Provider value={value}>
      {children}
    </TranslationsContext.Provider>
  );
};

export const useTranslations = () => {
  const context = useContext(TranslationsContext);
  if (!context) {
    throw new Error('useTranslations must be used within a TranslationsProvider');
  }
  return context;
};
